import { ShowingAttendanceConfig } from "@app/core/services/feature-config-manager/models/showing-attendance-config";

export const buildShowingAttendanceConfiguration =
  (): ShowingAttendanceConfig => {
    const displayAsDropdown = true;
    return {
      displayAsDropdown: displayAsDropdown,
    };
  };
